import{enableMapSet as e,freeze as t,produce as o}from"immer";export{immerable,produce}from"immer";import{createPluginCenter as n,request as r,markdown as i}from"@topwrite/core";export{BaseConfig,Book,Config,File,LetterAvatar,Level,Summary,SummaryArticle,SummaryPart,aes,isCancel,isEncryptedData,isRequestError,isUrl,markdown,md5,pluginCenter,request}from"@topwrite/core";import s from"url";import{jsx as a,Fragment as c,jsxs as l}from"react/jsx-runtime";import d,{Suspense as u,Fragment as h,Component as m,useMemo as p,createElement as f,createContext as g,useContext as b,useState as w,useCallback as v,useEffect as x,useRef as y,Children as k,forwardRef as E}from"react";import S from"@babel/runtime/helpers/defineProperty";import{useSelector as C,Model as $,createStore as P,Provider as M,useActions as L}from"@topthink/redux-model";export{Model}from"@topthink/redux-model";import z from"loadjs";export{default as loadjs}from"loadjs";import j from"query-string";import D,{createGlobalStyle as T}from"styled-components";export{ThemeProvider,createGlobalStyle,css,keyframes,default as styled}from"styled-components";import{createIntlCache as A,createIntl as I,RawIntlProvider as O}from"react-intl";export{IntlContext,defineMessage,defineMessages,useIntl}from"react-intl";import _ from"remark-slug";import{toc as N}from"mdast-util-toc";import{all as W,toHast as F}from"mdast-util-to-hast";import{convert as U}from"unist-util-is";import{toString as V}from"mdast-util-to-string";import{encode as q}from"mdurl";import H from"html-tags";import{debounce as B,throttle as R}from"lodash";export{default as useEvent}from"@react-hook/event";export{useHotkeys}from"react-hotkeys-hook";export{useAsync,useAsyncCallback}from"react-async-hook";export{Helmet}from"react-helmet";e(),window.TopWritePlugins={};class G extends HTMLElement{connectedCallback(){this.addEventListener("click",(e=>{if(e.preventDefault(),!this.isContentEditable){const e=this.attributes.getNamedItem("src");let t=e?.value;if(t){let e=document.createElement("a");e.download=this.textContent||"",e.style.display="none",e.target="_blank",e.href=s.resolve(location.href,t),document.body.appendChild(e),e.click(),document.body.removeChild(e)}}}))}}function J(e){let{component:t,defaultComponent:o=h,props:n,children:r=null,context:i}=e;return null===t?null:a(u,{fallback:null,children:a(t,{props:n,Component:o,context:i,children:r})})}customElements.define("t-attachment",G);class K extends m{constructor(){super(...arguments),S(this,"state",{hasError:!1})}componentDidCatch(){this.setState({hasError:!0})}render(){return this.state.hasError?null:this.props.children}}var Q=(e,t)=>e.filter((e=>{let{descriptor:o}=e;return t===o.role})).sort(((e,t)=>{let{descriptor:{priority:o=0}}=e,{descriptor:{priority:n=0}}=t;return o-n})).map((e=>{return t=e.Component,e=>a(K,{children:a(t,{...e},"WrappedComponent")});var t}));function X(e){let{component:t,props:o}=e;return f(t,o)}function Y(e){let{props:t,role:o,component:n,context:r}=e;const i=n?a(X,{component:n,props:t,context:r}):null,s=C("components");return p((()=>Q(s,o)),[s,o]).reduce(((e,o)=>a(J,{defaultComponent:n,component:o,props:t,context:r,children:e})),i)}function Z(e){let{props:t,component:o,role:n,context:r}=e;const i=C("components"),s=p((()=>Q(i,n)),[i,n]);return a(c,{children:s.map(((e,n)=>a(J,{defaultComponent:o,component:e,props:t,context:r},n)))})}async function ee(e){let t=`topwrite-plugin-${e.name}`;if(!z.isDefined(t)){let o=`${e.host}/${e.main}`;try{await z(o,t,{returnPromise:!0})}catch{console.warn(`插件${e.name}加载失败`)}}}const te="localStorage";function oe(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:te;if("undefined"==typeof window)throw new Error("Browser storage is not available on NodeJS / TopWrite SSR process");if("none"===e)return null;try{return window[e]}catch(e){return null}}const ne={get:()=>null,set:()=>{},del:()=>{}},re=(e,t)=>{const o=oe(t?.persistence);return o?{get:()=>o.getItem(e),set:t=>o.setItem(e,t),del:()=>o.removeItem(e)}:ne};function ie(){const e=oe(arguments.length>0&&void 0!==arguments[0]?arguments[0]:te);if(!e)return[];const t=[];for(let o=0;o<e.length;o+=1){const n=e.key(o);null!==n&&t.push(n)}return t}function se(e,t){if(null===e)return t;if(void 0===t||"string"==typeof t)return e;try{return JSON.parse(e)}catch{return t}}class ae{constructor(){S(this,"listeners",new Map),S(this,"values",new Map)}subscribe(e,t){return this.listeners.has(e)||this.listeners.set(e,new Set),this.listeners.get(e).add(t),()=>{const o=this.listeners.get(e);o&&(o.delete(t),0===o.size&&this.listeners.delete(e))}}setValue(e,t,o){this.values.set(e,t);const n=re(e);t===o?n.del():n.set(function(e){return void 0===e||"string"==typeof e?e:JSON.stringify(e)}(t));const r=this.listeners.get(e);r&&r.forEach((e=>e(t)))}getValue(e,t){if(this.values.has(e))return this.values.get(e);const o=se(re(e).get(),t);return this.values.set(e,o),o}handleStorageEvent(e,t){if(e.key&&this.listeners.has(e.key)){const o=t.get(e.key),n=se(e.newValue,o);this.values.set(e.key,n);const r=this.listeners.get(e.key);r&&r.forEach((e=>e(n)))}}}const ce=g(null);function le(e){let{children:t}=e;const o=p((()=>new ae),[]),n=p((()=>new Map),[]);return x((()=>{const e=e=>{o.handleStorageEvent(e,n)};return window.addEventListener("storage",e),()=>window.removeEventListener("storage",e)}),[o,n]),a(ce.Provider,{value:o,children:t})}function de(e,t){const o=b(ce);if(!o)throw new Error("useLocalStorageState must be used within a LocalStorageStateProvider");const[n,r]=w((()=>o.getValue(e,t))),i=v((n=>{o.setValue(e,n,t)}),[o,e,t]);return x((()=>o.subscribe(e,r)),[o,e]),[n,i]}function ue(e,t){let o;return o=t instanceof Array?{Component:t[0],descriptor:{role:e,...t[1]}}:{Component:t,descriptor:{role:e}},o}function he(){const e=C("book");if(!e)throw new Error("book object not initialized");return e}const me={light:"light",dark:"dark"},pe=e=>e===me.dark?me.dark:me.light,fe=window.matchMedia?window.matchMedia("(prefers-color-scheme: dark)"):void 0,ge=()=>fe?.matches?me.dark:me.light,be=e=>{document.documentElement.setAttribute("data-theme",e)},we=g(void 0);function ve(e){let{children:t,context:o,theme:n}=e;const r=he(),[i,s]=de(`${o}.${r.id}.theme`,"auto"),[c,l]=w((()=>{let e;return e=n||"auto"!==i?pe(n||i):ge(),e}));x((()=>{if(fe&&!n&&"auto"===i){const e=e=>{e.matches?l(me.dark):l(me.light)};return fe.addEventListener("change",e),()=>{fe.removeEventListener("change",e)}}}),[i,n]),x((()=>{l("auto"==i?n||ge():pe(i))}),[i]),x((()=>{be(c)}),[c]);const d=v((()=>{s(me.light)}),[]),u=v((()=>{s(me.dark)}),[]),h=v((()=>{s("auto")}),[]),m=v((()=>{"auto"===i?d():c===me.light?u():h()}),[c,i,d,u]);return a(we.Provider,{value:{theme:c,isAutoTheme:"auto"===i,isDarkTheme:c===me.dark,setLightTheme:d,setDarkTheme:u,setAutoTheme:h,toggleTheme:m},children:t})}function xe(){const e=b(we);if(!e)throw new Error("theme context not exist");return e}const ye=T`
    :root {
        --ttw-color: #333;
        --ttw-primary-color: #3c60ff;
        --ttw-secondary-color: #9e9e9e;
        --ttw-gray-color: rgba(0, 0, 0, 0.5);
        --ttw-background: #fff;
        --ttw-border-color: #eaeaea;
        --ttw-box-color: #212529;
        --ttw-box-background: #FFF;
        --ttw-box-hover-background: #e9ecef;
        --ttw-box-active-background: #f1f2f2;
    }

    [data-theme=dark] {
        --ttw-color: #cacbcf;
        --ttw-secondary-color: #888;
        --ttw-gray-color: rgba(255, 255, 255, 0.5);
        --ttw-background: #1F2428;
        --ttw-border-color: #1B1F23;
        --ttw-box-color: #e1e4e8;
        --ttw-box-background: #2f363d;
        --ttw-box-hover-background: #39414a;
        --ttw-box-active-background: #242A30;
    }
    
    //TODO 转移到异步加载
    //附件
    t-attachment {
        color: var(--ttw-primary-color, #3c60ff);
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        overflow: hidden;
        padding: 0 4px;
        vertical-align: bottom;
        margin: 0 1px;

        &:before {
            content: '';
            width: 18px;
            height: 18px;
            background-color: var(--ttw-primary-color, #3c60ff);
            mask: url("${"data:image/svg+xml,%3csvg t='1642406480574' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2254' width='16' height='16'%3e %3cpath d='M874.666667 467.2c-10.666667-10.666667-29.866667-12.8-42.666667 0l-343.466667 341.333333c-74.666667 74.666667-198.4 74.666667-275.2 0-36.266667-36.266667-57.6-85.333333-57.6-136.533333s19.2-100.266667 57.6-136.533333L556.8 192c46.933333-46.933333 121.6-46.933333 168.533333 0 23.466667 23.466667 34.133333 53.333333 34.133334 83.2 0 32-12.8 61.866667-34.133334 83.2L384 704c-17.066667 17.066667-44.8 17.066667-64 0-8.533333-8.533333-12.8-19.2-12.8-32s4.266667-23.466667 12.8-32l317.866667-315.733333c10.666667-10.666667 12.8-29.866667 0-42.666667-10.666667-12.8-29.866667-12.8-42.666667 0L277.333333 597.333333c-19.2 19.2-29.866667 46.933333-29.866666 74.666667S258.133333 725.333333 277.333333 746.666667c40.533333 40.533333 106.666667 40.533333 147.2 0L768 403.2c34.133333-34.133333 53.333333-78.933333 53.333333-125.866667s-19.2-93.866667-53.333333-125.866666a178.986667 178.986667 0 0 0-253.866667 0l-341.333333 341.333333c-46.933333 46.933333-74.666667 110.933333-74.666667 179.2s25.6 132.266667 74.666667 179.2c49.066667 49.066667 115.2 74.666667 179.2 74.666667s130.133333-25.6 179.2-74.666667l343.466667-341.333333c10.666667-12.8 10.666667-32 0-42.666667z' p-id='2255'%3e%3c/path%3e%3c/svg%3e"}") no-repeat center;
            margin-right: 4px;
        }

        &:after {
            content: "(" attr(size) ")";
            margin-left: 4px;
            display: none;
        }

        &[size]:after {
            display: inline;
        }

        &:hover {
            background: rgba(0, 0, 0, .1);
        }

        &:read-write {
            cursor: text;
        }
    }
`;const ke=new class extends ${constructor(){super(...arguments),S(this,"initialState",[])}*register(e){yield this.setState((t=>t.push(e)))}};const Ee=new class extends ${};var Se=Object.freeze({__proto__:null,components:ke,options:Ee});const Ce=g(void 0),$e=()=>{const e=b(Ce);if(void 0===e)throw new Error("useIntlContext must be used within a Layout component");return e},Pe=e=>{let{children:t}=e;const{locale:o,messages:n}=$e(),r=p((()=>{const e=A();return I({locale:o,messages:n,defaultLocale:"en"},e)}),[o,n]);return a(O,{value:r,children:t})},Me=e=>{let{children:t,locale:o,messages:n}=e;const[r,i]=w(n);return a(Ce.Provider,{value:{locale:o,messages:r,setMessages:i},children:a(Pe,{children:t})})};function Le(e){return e.__esModule&&e.default?e.default:e}class ze{constructor(e,t,o){S(this,"name",void 0),S(this,"book",void 0),S(this,"models",{...Se}),S(this,"components",[]),S(this,"activates",[]),S(this,"plugins",[]),S(this,"initialState",void 0),this.name=e,this.book=t,this.initialState=o}registerComponents(e,t){for(let[o,n]of Object.entries(e))n&&("plugin:setting"===o&&(o=`plugin:setting:${t}`),this.components.push(ue(o,n)))}registerModels(e,t){for(const[o,n]of Object.entries(e))t?this.models[`@${t}@${o}`]=n:this.models[o]=n}async registerPlugins(e){this.plugins=e;for(const t of e)try{this.registerComponents(t.components,t.name),this.registerModels(t.models,t.name),t.activate&&this.activates.push(t.activate),t.register&&await t.register(this.name,this.book)}catch(e){console.log(e)}}async createApp(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:navigator.language,o=arguments.length>2?arguments[2]:void 0;t=this.detectLocale(t);const n=await this.loadMessages(t,e),r=P(this.models,{book:this.book,components:this.components,...this.initialState}),i=e=>{let{children:t}=e;return a(c,{children:t})},s=e=>{let{children:t}=e;const o=a(Y,{role:`activate:${this.name}`,props:{children:t,name:this.name},component:i});return this.activates.reduce(((e,t)=>{const o=t(this.name);return void 0!==o?a(c,{children:o}):e}),o)};return e=>{let{children:i}=e;return a(M,{store:r,children:a(le,{children:l(ve,{context:this.name,theme:o,children:[a(ye,{}),a(Me,{locale:t,messages:n,children:a(s,{children:i})})]})})})}}detectLocale(e){const t=re(`${this.name}.${this.book.id}.lang`);e=t.get()||e;const o=new URLSearchParams(window.location.search).get("lang");return o&&(t.set(o),e=o),document.documentElement.setAttribute("lang",e),e}async loadMessages(e,t){return await this.plugins.reduce((async(t,o)=>{const n=Le(await t);return o.localize?Object.assign({},n,Le(await o.localize(e))):n}),t(e))}}async function je(e){const{name:t,book:o,models:i,initialState:s,localize:a,pluginCenter:c,locale:l,theme:d}=e,u=await async function(e,t){let o=[];if(t){const r=n(t);try{o=await r.getInstalled(e),o=o.filter((e=>!window.TopWritePlugins[e.name]?.meta))}catch{}}try{const e=sessionStorage.getItem("PLUGIN_DEV"),t=j.parse(window.location.search);if("dev"in t||e){const n=t.dev||e||8080;try{const e=(await r.get(`http://localhost:${n}/meta`)).data;o=o.filter((t=>t.name!==e.name&&!("theme"===e.type&&"theme"===t.type))),window.TopWritePlugins[e.name]&&delete window.TopWritePlugins[e.name],o.unshift(e),sessionStorage.setItem("PLUGIN_DEV",String(n))}catch(e){console.warn(e),sessionStorage.removeItem("PLUGIN_DEV")}}}catch{}const i=Object.entries(window.TopWritePlugins).filter((e=>{let[,t]=e;return!!t.meta})).map((e=>{let[,t]=e;return t.meta})),s=i.some((e=>"theme"===e.type)),a=Object.keys(window.TopWritePlugins),c=[];for(let e of o)e.disabled||a.includes(e.name)||s&&"theme"===e.type||c.push(ee(e));return await Promise.all(c),i.push(...o),window.TopWritePluginsMeta=i,Object.values(window.TopWritePlugins||{})}(o,c),h=new ze(t,o,s);return h.registerModels(i),await h.registerPlugins(u),await h.createApp(a,l,d)}function De(e){return L(e)}function Te(e){return C(e)}function Ae(e){return[Te(e),De(e)]}function Ie(e,t,o){const n="function"==typeof t;n||(o=t),x((()=>{let o;const r=e();return Promise.resolve(r).then((e=>{o=e})),()=>{n&&t(o)}}),o)}function Oe(e){const t=y(null),[o,n]=w(e);x((()=>{t.current&&(t.current(),t.current=null)}),[o]);return[o,(e,o)=>{t.current="function"==typeof o?o:null,n(e)}]}function _e(){const e=document.currentScript;if(!e)throw new Error("Automatic publicPath is not supported in this browser");return e.src.replace(/#.*$/,"").replace(/\?.*$/,"").replace(/\/[^\/]+$/,"/")}class Ne{constructor(e){let{name:t,meta:o,models:n={},components:r={},activate:i,register:s,localize:a,config:c}=e;S(this,"name",void 0),S(this,"config",void 0),S(this,"localize",void 0),S(this,"models",void 0),S(this,"components",void 0),S(this,"activate",void 0),S(this,"register",void 0),S(this,"meta",void 0),this.name=t,this.meta=o,this.models=n,this.components=r,this.activate=i,this.register=s,this.localize=a,this.config=c}}const We=g({}),Fe=We.Provider,Ue=()=>b(We);function Ve(e,t){return Ue()[e]||t}const qe=U("root"),He=U("element"),Be=U("text");function Re(e){return e.filter((e=>!(Be(e)&&"\n"===e.value)))}function Ge(e,t,o){const n=t.properties,r=t.tagName,i={...n};o.prefix&&(o.key++,i.key=o.prefix+o.key);const s=[],a=Re(t.children),c=a?a.length:0;let l=-1;for(;++l<c;){const t=a[l];He(t)?s.push(Ge(e,t,o)):Be(t)&&s.push(t.value)}return e.call(t,r,i,s.length>0?s:void 0)}function Je(e,t){let{extensions:o=[],creator:n=d.createElement}=t;const r={allowDangerousHtml:!1,handlers:{...o.reduce(((e,t)=>Object.assign(e,t)),{}),textDirective:(e,t)=>e({},"textDirective",{name:t.name,attributes:t.attributes},W(e,t)),leafDirective:(e,t)=>e({},"leafDirective",{name:t.name,attributes:t.attributes},W(e,t)),containerDirective(e,t){"children"in t||(t.children=[]);let o=!1;for(const e of t.children)if(e.data?.directiveLabel){o=!0;break}return o||t.children.unshift({type:"paragraph",children:[{type:"text",value:""}]}),e({},"containerDirective",{name:t.name,attributes:t.attributes},W(e,t))},heading(e,t){const o=e(t,"heading",W(e,t));return o.properties={...o.properties,depth:t.depth},o}},unknownHandler:()=>null},i=F(e,r);if(qe(i))return Re(i.children).map(((e,t)=>He(e)?Ge(n,e,{key:0,prefix:`h-${t}-`}):Be(e)?e.value:void 0));if(!He(i))throw new Error("Expected root or element, not `"+(i&&i.type||i)+"`");return Ge(n,i,{key:0,prefix:"h-"})}function Ke(e){let{extensions:t,tree:o,options:n}=e;const r=p((()=>{let e=null;if(n){const r=N(o).map;r&&(e=Je(r,{extensions:[...t,{link:(e,t)=>{const o=V(t.children);return e(t,"a",{href:q(t.url)},[{type:"text",value:o}])}}]})),"object"==typeof n&&(e=l(c,{children:[n.header,e,n.footer]}))}return e}),[t,o,n]);return r?a("aside",{children:r}):null}const Qe=e=>{let{value:t}=e;return a("pre",{children:a("code",{children:t})})},Xe=e=>{let{value:t}=e;return a("code",{children:t})};const Ye=["video","audio","div"];function Ze(e){const{name:t,attributes:o,children:n}=e;let r=Ve(t),i=`html:${t}`;return customElements.get(`t-${t}`)?r=r||`t-${t}`:Ye.includes(t)||(r=void 0,i=`directive:${t}`),a(Y,{role:i,props:{...o,children:n},component:r})}function et(e){let{depth:t=5,...o}=e;return f(`h${t}`,o)}const tt={"x-inline":function(e){const{name:t,value:o}=e;return a(Y,{role:`inline:${t}`,props:{type:"inline",name:t,value:o},component:Xe})},"x-block":function(e){const{name:t,value:o,parameter:n}=e;return a(Y,{role:`block:${t}`,props:{type:"block",name:t,parameter:n,value:o},component:Qe})},textDirective:Ze,leafDirective:Ze,containerDirective:function(e){let{name:t,attributes:o,children:n}=e,r=Ve(t),i=`html:${t}`;const[s,...c]=k.toArray(n),l={children:c,label:s,...o};return customElements.get(`t-${t}`)?r=r||`t-${t}`:Ye.includes(t)?l.label=void 0:(r=void 0,i=`directive:${t}`),a(Y,{role:i,props:l,component:r})},heading:function(e){const t=Ve("heading",et);return a(Y,{role:"html:heading",props:e,component:t})}},ot=e=>{let{tagName:t,inject:o=!0,...n}=e;const r=Ve(t,t);return o?tt[t]?f(tt[t],n):H.includes(t)?a(Y,{role:`html:${t}`,props:n,component:r}):(console.warn(`unknown tagName: ${t}`),null):f(r,n)};function nt(e){let{tree:t,extensions:o,as:n,css:r,header:i,footer:s,inject:c}=e;const d=p((()=>Je(t,{extensions:o,creator:(e,t,o)=>f(ot,{...t,tagName:e,inject:c},o)})),[t,o]);return l("article",{children:[i,a(rt,{$css:r,as:n,children:d}),s]})}const rt=D.section`
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    line-height: 1.2;
    word-wrap: break-word;

    & > *:first-child {
        margin-top: 0 !important;
    }

    & > *:last-child {
        margin-bottom: 0 !important;
    }

    h1, h2, h3, h4, h5, h6, p, ul, ol, blockquote, pre, table, audio, video {
        margin-top: 0;
        margin-bottom: 1rem;
        line-height: 1.5;
        padding: 0;

        &:last-child {
            margin-bottom: 0 !important;
        }

        &:first-child {
            margin-top: 0 !important;
        }
    }

    h1, h2, h3, h4, h5, h6 {
        font-weight: 500;
        margin-top: 2rem;
        margin-bottom: 1rem;
        line-height: 1.2;

        &.align-right {
            text-align: right;
        }

        &.align-center {
            text-align: center;
        }
    }

    h1 {
        font-size: 2.5em;
    }

    h2 {
        font-size: 2em;
    }

    h3 {
        font-size: 1.75em;
    }

    h4 {
        font-size: 1.5em;
    }

    h5 {
        font-size: 1.25em;
    }

    hr {
        border: 0;
        border-bottom: 1px solid #eeeeee;
        margin-bottom: 0.5em;
    }

    ul {
        padding-left: 2em;

        ul {
            margin: 0;
        }
    }

    ol {
        padding-left: 2em;
    }

    li {
        line-height: 2;

        &.task-list-item {
            list-style: none;
            position: relative;

            input[type=checkbox] {
                position: absolute;
                left: -1.5em;
                top: 0.5em;
                width: 1em;
                height: 1em;
            }
        }

        &.align-right {
            text-align: right;
        }

        &.align-center {
            text-align: center;
        }
    }

    code {
        display: inline-block;
        border-radius: 4px;
        padding: .2em .4em;
        background-color: #f7f7f7;
        word-break: break-all;
        font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
        white-space: pre;
        line-height: 1.3;
        color: inherit;
        font-size: inherit;
        margin: -.2em .4em;
    }

    pre {
        padding: 1.05em;
        overflow: auto;
        line-height: 1.45;
        background-color: #f7f7f7;
        border: 0;
        border-radius: 3px;
        font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
        font-size: inherit;
    }


    pre > code {
        display: inline;
        max-width: 100%;
        padding: 0;
        margin: 0;
        overflow: initial;
        line-height: inherit;
        background-color: rgba(0, 0, 0, 0);
        border: 0;
        tab-size: 4;
    }

    p {
        &.align-right {
            text-align: right;
        }

        &.align-center {
            text-align: center;
        }
    }

    table {
        border-collapse: collapse;
        table-layout: fixed;
        width: 100%;
        line-height: 1.8;
        border-spacing: 0;

        th {
            text-align: left;

            &[align='center'] {
                text-align: center;
            }

            &[align='right'] {
                text-align: right;
            }
        }

        th, td {
            border: 1px solid #e0e0e0;
            padding: 3px 12px;
            height: 34px;
        }

        tr:hover td {
            background-color: #f1f1f1;
        }
    }

    img {
        max-width: 100%;
        display: inline-block;
        padding: 3px;
        vertical-align: middle;
    }

    a {
        text-decoration: none;
        color: var(--ttw-primary-color, #3c60ff);

        &:hover {
            text-decoration: underline;
        }
    }

    blockquote {
        padding: 5px 5px 5px 15px;
        color: #858585;
        border-left: 4px solid #e5e5e5;

        &.info {
            border-left-color: #5bc0de;
            color: #5bc0de;
            background-color: #f4f8fa;
        }

        &.warning {
            background-color: #fcf8f2;
            border-color: #f0ad4e;
            color: #f0ad4e;
        }

        &.danger {
            color: #d9534f;
            background-color: #fdf7f7;
            border-color: #d9534f;
        }

        &.success {
            background-color: #f3f8f3;
            border-color: #50af51;
            color: #50af51;
        }
    }

    video {
        display: block;
        width: 100%;
    }

    audio {
        display: block;
        width: 100%;
    }

    [data-theme=dark] & {
        code {
            background-color: #333437;
        }

        pre {
            background-color: #333437;
        }

        h1, h2, hr {
            border-color: #404040;
        }

        th, td {
            border-color: #404040;
        }

        tr:hover td {
            background-color: #333437;
        }

        blockquote {
            border-left-color: #858585;

            &.info {
                border-left-color: rgb(27, 110, 134);
                color: rgb(98, 195, 223);
                background-color: rgb(19, 34, 42);
            }

            &.warning {
                background-color: rgb(49, 34, 11);
                border-color: rgb(147, 91, 12);
                color: rgb(241, 176, 84);
            }

            &.danger {
                color: rgb(219, 94, 90);
                background-color: rgb(46, 11, 11);
                border-color: rgb(137, 33, 30);
            }

            &.success {
                background-color: rgb(27, 39, 23);
                border-color: rgb(56, 122, 57);
                color: rgb(98, 183, 98);
            }
        }
    }

    ${e=>e.$css}
`,it=E(((e,t)=>{let{class:o,...n}=e;return a("div",{ref:t,className:o,...n})}));function st(e){let{as:t=h,children:o,components:n={},aside:r=!0,header:s,footer:c,css:d,sectionAs:u,inject:m=!0,loader:g=null,onShow:b,...v}=e;const y=p((()=>i().use(_).freeze()),[]),[k,E]=w(g),[S,C]=w(null);return Ie((async()=>{try{const e=await y.run(y.parse(o));C(e)}catch(e){console.warn(e),C(!1)}}),[o,y]),x((()=>{if(null!==S){if(!1===S)E(null);else if(S){const e=y.data("toHastExtensions");E(l(Fe,{value:{div:it,...n},children:[a(nt,{tree:S,extensions:e,header:s,footer:c,as:u,css:d,inject:m}),a(Ke,{tree:S,extensions:e,options:r})]}))}b&&requestAnimationFrame(b)}}),[S,r,s,c,d,u,m]),f(t,v,k)}function at(e){let{onChange:t,onCompositionStart:o,onCompositionEnd:n,...r}=e;const i=y(!1),s=v((e=>{i.current||t?.(e)}),[t]),c=v((e=>{i.current=!0,o?.(e)}),[o]),l=v((e=>{i.current=!1,t?.(e),n?.(e)}),[n,t]);return a("input",{...r,onChange:s,onCompositionStart:c,onCompositionEnd:l})}function ct(e){const t=y();return x((()=>{t.current=e}),[e]),t.current}function lt(){const{config:e}=he();return e.getValue("themeConfig")}function dt(e){const t=y(e);x((()=>(document.title=e,()=>{document.title=t.current})),[e])}function ut(e,t,o){const n=y(e),r=y(B(e,t,o));return x((()=>{n.current=e})),x((()=>{r.current=B((function(){n.current(...arguments)}),t,o)}),[t,o]),r.current}function ht(e,t,o){const n=y(e),r=y(R(e,t,o));return x((()=>{n.current=e})),x((()=>{r.current=R((function(){n.current(...arguments)}),t,o)}),[t,o]),r.current}function mt(){return C("options")}function pt(e){const[n,r]=w((()=>t("function"==typeof e?e():e,!0)));return[n,v((e=>{r("function"==typeof e?o(e):t(e))}),[])]}const ft=new EventTarget;function gt(){return ft}function bt(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.document;if("string"==typeof e){e=(new DOMParser).parseFromString(e,"text/html")}const t=e.querySelector('script[type="application/payload+json"]');if(t)try{return JSON.parse(t.innerHTML)}catch{return{}}}var wt=Object.freeze({__proto__:null,encode:function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(null===e)return"";try{return window.btoa(unescape(encodeURIComponent(e)))}catch(e){if(t)throw e;return""}},decode:function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(null===e)return"";try{return decodeURIComponent(escape(window.atob(e)))}catch(e){if(t)throw e;return""}}});function vt(){return"undefined"!=typeof window&&/Mac|iPod|iPhone|iPad/.test(window.navigator.platform)}export{at as CompositionInput,Y as InjectedComponent,Z as InjectedComponentSet,st as Markdown,Ne as Plugin,wt as base64,je as createApplication,ue as createComponentDescriptor,re as createStorageSlot,bt as getPayload,_e as getPublicPath,vt as isMac,ie as listStorageKeys,De as useActions,Ie as useAsyncEffect,he as useBook,ut as useDebounce,dt as useDocumentTitle,gt as useEventTarget,pt as useImmer,$e as useIntlContext,de as useLocalStorageState,Ae as useModel,mt as useOptions,ct as usePrevious,Te as useSelector,Oe as useStateWithCallback,lt as useThemeConfig,xe as useThemeContext,ht as useThrottle};
//# sourceMappingURL=index.js.map
